import { chartGradientOptions } from './config';
import { ChartBoxGradient, GradientStop, AttrsMap } from './models/index';

function addChartGradient(chart: gv.LineChart) : void {
  if (chart.getContainer == null) return;
  
  const chartDiv = chart.getContainer();
  const svg = chartDiv.getElementsByTagName('svg')[0];
  const chartPath = svg.getElementsByTagName('path')[0];

  drawGradient(svg, chartGradientOptions);
  chartPath.setAttribute('stroke', 'url(#chartGradient)');
}

function drawGradient(svg: SVGElement, properties: ChartBoxGradient) : void { 
  const svgNS = svg.namespaceURI;
  const gradient = document.createElementNS(svgNS, 'linearGradient');
  const coordinatesNames = ['x1', 'y1', 'x2', 'y2'];
  
  gradient.setAttribute('id', properties.id);
  setElementAttributes(gradient, coordinatesNames, properties);

  properties.stops.forEach((attrs: GradientStop) => {
    const stop = document.createElementNS(svgNS, 'stop');
    setElementAttributes(stop, Object.keys(attrs), attrs); 
    gradient.appendChild(stop); 
  });

  if (svg.querySelector('defs') != null) { 
    const defs = svg.insertBefore(document.createElementNS(svgNS, 'defs'), svg.firstChild);
    defs.appendChild(gradient);
  } 
}

function setElementAttributes(
  element: Element, 
  attrNames: string[], 
  properties: AttrsMap, 
) : void {
  attrNames.forEach((attr: string) => {
    element.setAttribute(attr, properties[attr]); 
  });
}

export default addChartGradient;

